exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-pricing,.c-pricing__cost,.c-pricing__credits,.c-pricing__item{border:none}.c-pricing{border-collapse:collapse;-ms-flex-item-align:start;align-self:flex-start}.c-pricing__item:before{content:\"\";display:list-item;list-style-type:circle;margin-left:1.25rem}.c-pricing__cost__price{color:tomato}.c-pricing__credits{color:#000}.c-pricing__services{padding:20px}", ""]);

// exports
